module.exports = __webpack_public_path__ + "media/icons/opony-felgi-baner@3x-a9465c0c.svg";